import type { DemoKey } from './keys';

export const ko: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': '기하학 · 3D',
  'panel.figure': '도형',
  'panel.dims': '치수',
  'panel.style': '외관',
  'panel.lines': '특수 선',
  'style.body': '본체',
  'style.line': '선',
  'style.cut': '단면',
  'style.labels': '꼭짓점 라벨',
  'group.face': '면 대각선 / 모선',
  'group.space': '대각선 / 축 / 중선',
  'split.label': '단면',
  'btn.animate': '애니메이션',
  'btn.reset': '재설정',
  'hint.line1': '드래그로 회전 · 스크롤로 확대',
  'hint.line2': '선을 클릭하여 선택',
  'fig.cuboid': '직육면체',
  'fig.cube': '정육면체',
  'fig.triPrism': '삼각기둥',
  'fig.hexPrism': '육각기둥',
  'fig.tetrahedron': '정사면체',
  'fig.squarePyramid': '사각뿔',
  'fig.cylinder': '원기둥',
  'fig.cone': '원뿔',
  'fig.sphere': '구',
  'fig.frustumPyramid': '각뿔대',
  'fig.frustumCone': '원뿔대',
  'dim.length': '길이',
  'dim.width': '너비',
  'dim.height': '높이',
  'dim.side': '변',
  'dim.radius': '반지름',
  'dim.r1': '아래 반지름',
  'dim.r2': '위 반지름',
  'dim.sideBase': '밑변',
  'dim.sideTop': '윗변',
  'info.face': '면',
  'info.center': '중심 통과',
  'info.diagonal': '대각선',
  'info.axial': '축 대각선',
  'info.diameter': '지름',
  'info.generator': '모선',
  'info.axis': '축',
  'info.height': '높이',
  'info.median': '중선',
  'info.apothem': '아포텐',
  'info.diameterBase': '밑면 지름',
  'info.diameterTop': '윗면 지름',
};
